import {isUserHasRole} from './user';

export const isIamCoach = (): boolean => isUserHasRole('coach');

export const isIamCorporateCoach = (): boolean =>
  isIamCoach() && isUserHasRole('approved_corporate_coach');
